import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { SvgCloseButton } from '../../../gen-src/icons/CloseButton';
import { TitleBarContainer, TitleTextCssClass } from './ViewerPaneStyles';

export const lineagePanelCloseButtonTestId = 'lineage-panel-close-button';
export const lineagePanelTitleTestId = 'lineage-panel-title';

export interface VizClientLineagePanelTitleBarProps {
  readonly title: string;
  readonly onCloseRequested: () => void;
}

export class VizClientLineagePaneTitleBar extends React.Component<VizClientLineagePanelTitleBarProps> {
  private readonly domRef: React.RefObject<HTMLDivElement> = React.createRef();

  public componentDidMount(): void {
    const rootElement = this.domRef.current;
    if (rootElement) {
      // find the element defined as focussable by the tabindex attribute
      const focusableElement = rootElement.querySelector<HTMLElement>('[tabindex="0"]');
      if (focusableElement) {
        focusableElement.focus();
      }
    }
  }

  public renderCloseButton(): JSX.Element | null {
    if (this.props.onCloseRequested === null) {
      return null;
    }

    return (
      <ButtonWidget
        buttonType={ButtonType.Icon}
        handleClick={this.props.onCloseRequested}
        title={Messages.CloseButtonTitle()}
        testId={lineagePanelCloseButtonTestId}
        style={{ padding: 0 }}
        getContent={() => <SvgCloseButton />}
      />
    );
  }

  public render(): JSX.Element {
    return (
      <div ref={this.domRef}>
        <TitleBarContainer>
          <h3 className={TitleTextCssClass} data-tb-test-id={lineagePanelTitleTestId}>
            {this.props.title}
          </h3>
          {this.renderCloseButton()}
        </TitleBarContainer>
      </div>
    );
  }
}
